import React, { lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
// Components
import Header from './header/Header';
// Utils
import SuspenseWrapper from '../utils/SuspenseWrapper/SuspenseWrapper';

const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'));
const UserProfile = lazy(() => import('../pages/UserProfile/UserProfile'));
const UserSettings = lazy(() => import('../pages/UserSettings/UserSettings'));
const ContactUs = lazy(() => import('../pages/ContactUs/ContactUs'));
const ScalensIR = lazy(() => import('../pages/ScalensIR/ScalensIR'));
const Monitor = lazy(() => import('../pages/Monitor/Monitor'));
const MonitorCardViewer = lazy(() => import('../pages/Monitor/MonitorCardViewer'));
const CRM = lazy(() => import('../pages/CRM/MainCRM'));
const OAuthCallback = lazy(() => import('../pages/OAuthCallback'));

// Keep the query string: after an Auth0 login the callback lands on `/?code=...&state=...`,
// and the SDK must still see those params once we've redirected.
function RedirectToMonitor() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/monitor', search, hash }} replace />;
}

function Layout() {
  return (
    <>
      <Header />
      <div className="container mt-[5.5rem] relative m-auto">
        <Routes>
          <Route path="/" element={<RedirectToMonitor />} />
          <Route path="/home" element={<SuspenseWrapper LazyComponent={Dashboard} />} />
          <Route path="/profile" element={<SuspenseWrapper LazyComponent={UserProfile} />} />
          <Route path="/settings" element={<SuspenseWrapper LazyComponent={UserSettings} />} />
          <Route path="/contact" element={<SuspenseWrapper LazyComponent={ContactUs} />} />
          <Route path="/scalens-ir" element={<SuspenseWrapper LazyComponent={ScalensIR} />} />
          <Route path="/monitor" element={<SuspenseWrapper LazyComponent={Monitor} />} />
          <Route
            path="/monitor/card/:slug"
            element={<SuspenseWrapper LazyComponent={MonitorCardViewer} />}
          />
          <Route path="/crm" element={<SuspenseWrapper LazyComponent={CRM} />} />
          <Route
            path="/google_gmail/confirm"
            element={<SuspenseWrapper LazyComponent={OAuthCallback} />}
          />
          <Route
            path="/microsoft_outlook/confirm"
            element={<SuspenseWrapper LazyComponent={OAuthCallback} />}
          />
        </Routes>
      </div>
    </>
  );
}

export default Layout;
